const src = import.meta.ROLLUP_FILE_URL_OestAvA2SyLT4CG6L76dAw;
export default {
  src,
  srcSet: src + " " + 1024 + "w",
  width: 1024,
  height: 1024,
};